// Hero Slider Auto-play Enhancement
document.addEventListener('DOMContentLoaded', function() {
  const heroSliders = document.querySelectorAll('[id^="HeroSlider-"] slider-component');

  heroSliders.forEach(function(sliderComponent) {
    const wrapper = sliderComponent.closest('[id^="HeroSlider-"]');
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const prevButton = sliderComponent.querySelector('button[name="previous"]');
    const nextButton = sliderComponent.querySelector('button[name="next"]');

    // Shared: transition mode, viewport matcher, visible-slide helpers
    const isFade = (wrapper && wrapper.getAttribute('data-transition')) === 'fade';
    const mobileQuery = window.matchMedia('(max-width: 750px)');

    function getRenderedSlides() {
      if (!slider) return [];
      return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function(s) {
        return s.offsetParent !== null || s.getClientRects().length > 0;
      });
    }

    function getVisibleSlidesShared() {
      const isMobile = mobileQuery.matches;
      return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function(slide) {
        const vis = slide.getAttribute('data-visibility') || 'all';
        if (vis === 'all') return true;
        if (vis === 'desktop_only') return !isMobile;
        if (vis === 'mobile_only') return isMobile;
        return true;
      });
    }

    function getActiveSlideShared() {
      const slides = getRenderedSlides();
      if (!slides.length) return null;
      if (isFade) {
        return slides.find(function(s) { return s.classList.contains('is-active'); }) || slides[0];
      }
      const w = slider.offsetWidth || 1;
      const idx = Math.min(Math.max(0, Math.round(slider.scrollLeft / w)), slides.length - 1);
      return slides[idx];
    }

    // Fade mode: mark first visible slide active on init + stop slider-component
    // from disabling the arrows (it thinks every slide is at scrollLeft 0 in fade mode)
    if (isFade) {
      const initial = getVisibleSlidesShared();
      if (initial.length && !initial.some(function(s) { return s.classList.contains('is-active'); })) {
        initial[0].classList.add('is-active');
      }
      // slider-component's update() disables arrows when first/last slide is "visible".
      // In fade mode every slide overlaps at offsetLeft 0, which trips the disable logic.
      // Setting enableSliderLooping=true makes update() return before that branch.
      try { sliderComponent.enableSliderLooping = true; } catch (_) {}
      if (prevButton) prevButton.removeAttribute('disabled');
      if (nextButton) nextButton.removeAttribute('disabled');
      // Safety net: if anything re-adds `disabled`, strip it immediately.
      const unDisable = function(btn) {
        if (!btn) return;
        new MutationObserver(function(mutations) {
          mutations.forEach(function(m) {
            if (m.attributeName === 'disabled' && btn.hasAttribute('disabled')) {
              btn.removeAttribute('disabled');
            }
          });
        }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      };
      unDisable(prevButton);
      unDisable(nextButton);
    }

    // Per-slide fit-media height: size the slider container to the *active* slide's media,
    // so multi-slide decks with different aspect ratios don't leave a blank gap below the
    // shorter slides.
    if (wrapper && wrapper.querySelector('.hero-slide--fit-media')) {
      const isMobileQuery = mobileQuery;

      function getActiveSlide() {
        return getActiveSlideShared();
      }

      function getVisibleMediaIn(slide) {
        if (!slide) return null;
        // Pick the media element that's actually displayed at the current viewport
        const medias = slide.querySelectorAll('.hero-slide__image, .hero-slide__video');
        for (let i = 0; i < medias.length; i++) {
          const m = medias[i];
          const style = window.getComputedStyle(m);
          if (style.display !== 'none' && style.visibility !== 'hidden' && m.offsetWidth > 0) {
            return m;
          }
        }
        return medias[0] || null;
      }

      function mediaDimensions(media) {
        if (!media) return null;
        if (media.tagName === 'VIDEO' && media.videoWidth > 0 && media.videoHeight > 0) {
          return { w: media.videoWidth, h: media.videoHeight };
        }
        if (media.tagName === 'IMG' && media.naturalWidth > 0 && media.naturalHeight > 0) {
          return { w: media.naturalWidth, h: media.naturalHeight };
        }
        return null;
      }

      function getLayoutForSlide(slide) {
        if (slide.querySelector('.hero-slide--split_screen')) return 'split_screen';
        if (slide.querySelector('.hero-slide--image_text')) return 'image_text';
        return 'full_screen';
      }

      function applyHeightForActiveSlide() {
        const slide = getActiveSlide();
        // Only resize to fit-media slides — non-fit-media slides keep their parent height
        if (!slide || !slide.classList.contains('slider__slide--fit-media')) return;
        const media = getVisibleMediaIn(slide);
        const dims = mediaDimensions(media);
        if (!dims) return;

        // For split/image-text layouts the media sits in a half-width column on desktop.
        // On mobile the split fade stack is full-width. Full-screen always uses full width.
        const layout = getLayoutForSlide(slide);
        const isMobile = isMobileQuery.matches;
        let aspectW = dims.w;
        const aspectH = dims.h;
        if (!isMobile && (layout === 'split_screen' || layout === 'image_text')) {
          aspectW = dims.w * 2; // half-width column → slider needs 2x the intrinsic width
        }

        // Update aspect-ratio CSS var instead of pixel heights so CSS handles resize.
        const aspectVar = isMobile ? '--aspect-mobile' : '--aspect-desktop';
        wrapper.style.setProperty(aspectVar, aspectW + ' / ' + aspectH);
      }

      // Initial pass + retries while media metadata loads
      requestAnimationFrame(applyHeightForActiveSlide);

      const allImgs = slider.querySelectorAll('img.hero-slide__image');
      allImgs.forEach(function(img) {
        if (img.complete && img.naturalHeight > 0) return;
        img.addEventListener('load', function() { setTimeout(applyHeightForActiveSlide, 30); });
      });
      const allVideos = slider.querySelectorAll('video.hero-slide__video');
      allVideos.forEach(function(v) {
        if (v.readyState >= 2) return;
        v.addEventListener('loadedmetadata', applyHeightForActiveSlide);
      });

      // Poll briefly to catch late-resolving natural dimensions
      let retries = 0;
      const retryId = setInterval(function() {
        applyHeightForActiveSlide();
        if (++retries >= 10) clearInterval(retryId);
      }, 400);

      // Update on slide change (scroll-snap)
      let scrollTimer = null;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(applyHeightForActiveSlide, 60);
      });

      window.addEventListener('resize', applyHeightForActiveSlide);
      isMobileQuery.addEventListener('change', function() {
        // Give the viewport visibility CSS a tick to settle
        setTimeout(applyHeightForActiveSlide, 30);
      });
    }

    // Navigation: scroll (default) vs class-toggle (fade)
    let currentSlideIndex = 0;

    function getVisibleSlides() {
      return getVisibleSlidesShared();
    }

    function goToVisibleIndex(index) {
      const visible = getVisibleSlides();
      if (!visible.length) return;
      const clamped = ((index % visible.length) + visible.length) % visible.length;
      const target = visible[clamped];
      if (!target) return;
      if (isFade) {
        visible.forEach(function(s) { s.classList.remove('is-active'); });
        target.classList.add('is-active');
      } else {
        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    // Arrow handlers work regardless of autoplay state.
    // In fade mode we intercept in the capture phase and call stopImmediatePropagation
    // so slider-component's native scroll listener on the same button doesn't also fire.
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        if (isFade) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }
        const v = getVisibleSlides();
        if (!v.length) return;
        currentSlideIndex = (currentSlideIndex - 1 + v.length) % v.length;
        goToVisibleIndex(currentSlideIndex);
        if (typeof handleUserInteraction === 'function') handleUserInteraction();
      }, true); // capture phase — fires before slider-component's default target-phase listener
    }

    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        if (isFade) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }
        const v = getVisibleSlides();
        if (!v.length) return;
        currentSlideIndex = (currentSlideIndex + 1) % v.length;
        goToVisibleIndex(currentSlideIndex);
        if (typeof handleUserInteraction === 'function') handleUserInteraction();
      }, true);
    }

    // Autoplay (only if enabled)
    if (!slider || !slider.dataset.autoplay || slider.dataset.autoplay !== 'true') return;

    const autoplaySpeed = parseInt(slider.dataset.speed) * 1000 || 7000;
    let autoplayTimer = null;
    let isUserInteracting = false;

    function startAutoplay() {
      if (isUserInteracting) return;
      stopAutoplay();

      const visible = getVisibleSlides();
      if (visible.length < 2) return; // Nothing to rotate

      autoplayTimer = setInterval(function() {
        if (isUserInteracting) return;
        const v = getVisibleSlides();
        if (v.length < 2) return;
        currentSlideIndex = (currentSlideIndex + 1) % v.length;
        goToVisibleIndex(currentSlideIndex);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function handleUserInteraction() {
      isUserInteracting = true;
      stopAutoplay();
    }

    setTimeout(startAutoplay, 1000);

    mobileQuery.addEventListener('change', function() {
      currentSlideIndex = 0;
      isUserInteracting = false;
      if (isFade) {
        const v = getVisibleSlides();
        if (v.length) {
          v.forEach(function(s) { s.classList.remove('is-active'); });
          v[0].classList.add('is-active');
        }
      } else if (slider.scrollTo) {
        slider.scrollTo({ left: 0, behavior: 'auto' });
      }
      startAutoplay();
    });

    // Stop autoplay on direct slide click (body area), but don't fight arrow buttons.
    slider.addEventListener('click', function(e) {
      if (e.target.closest('.slider-button')) return;
      handleUserInteraction();
    });
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', function() {
      if (!isUserInteracting) startAutoplay();
    });
    slider.addEventListener('touchstart', handleUserInteraction);
  });
});
